// Formatting shared by the Billing page components.

export const formatMoney = (cents: number | null | undefined, currency = "usd"): string => {
  if (cents == null) return "";
  const whole = cents % 100 === 0;
  try {
    return (cents / 100).toLocaleString("en-US", {
      style: "currency",
      currency: currency.toUpperCase(),
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2,
    });
  } catch {
    return `$${(cents / 100).toFixed(whole ? 0 : 2)}`;
  }
};

export const formatDay = (iso: string | null | undefined): string =>
  iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "";

export const formatCount = (n: number | null | undefined): string => (n ?? 0).toLocaleString("en-US");

export const formatMb = (mb: number): string =>
  mb >= 1000 ? `${Number.isInteger(mb / 1000) ? mb / 1000 : (mb / 1000).toFixed(1)} GB` : `${Math.round(mb)} MB`;

/** "$3.80" per 1,000 credits for a plan or top-up. */
export const perThousand = (cents: number, credits: number): string =>
  credits > 0 ? formatMoney(Math.round((cents / credits) * 1000), "usd") : "";
